module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/481.aee2ad64.png";